var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"addSlack\">\n    <span class=\"explanation addSlack__or\">OR</span>\n    <button type=\"button\" class=\"addSlack__button light\">\n        <span>\n            <i class=\"fa fa-slack\"></i>\n            Add Slack Workspace\n        </span>\n    </button>\n</div>\n<p class=\"userError addSlack__error\"></p>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/src/view/add-slack.hbs
// module id = FXrJ
// module chunks = 1